<template>
  <div v-if="isHelpModalOpen" class="helpModal">
    <div class="helpModal-background" @click="closeHelpModal"></div>
    <div class="helpModal-content">
      <h5 class="title is-5">AIモード</h5>
      <br />
      <p>トレイルカメラを設置する場所を想定した害獣検知の方法です。</p>
      <p>
        それぞれ以下のような特長、メリット・デメリットがありますので、適宜設定を切り替えてご活用ください。
      </p>
      <br />
      <h5 class="title is-5">1. 天井裏</h5>
      <p>害獣の動きに注目した検出方法です。＊デフォルト設定</p>
      <p>
        ・ メリット ：比較的大きな物体（天井裏での作業者など）は非検出にします。
      </p>
      <p>・ デメリット：大きく映る害獣をとり逃す可能性があります。</p>
      <br />
      <h5 class="title is-5">2. 天井裏（感度高）</h5>
      <p>
        害獣の動きに注目した検出方法です。比較的大きな物体についても検出を有効とします。
      </p>
      <p>
        誤検出は許容するが、検出漏れをできる限り避けたい場合に推奨するモードです。
      </p>
      <p>・ メリット ：大きく映る害獣も検出します。</p>
      <p>
        ・ デメリット：比較的大きな物体（天井裏での作業者など）も検出します。
      </p>
      <br />
      <h5 class="title is-5">3. 居室</h5>
      <p>害獣の形を重視した検出です。</p>
      <p>誤診を少なくしたい場合に推奨するモードです。</p>
      <p>・ メリット ：人やモノなどによる誤検出の低減します。</p>
      <p>・ デメリット：検出漏れが増加します。</p>
      <br />
      <button @click="closeHelpModal" class="button is-danger ml-3">
        閉じる
      </button>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "UndetectedAreaJa",
  props: {
    isHelpModalOpen: Boolean,
  },
  emits: ["close"],
  setup(props, { emit }) {
    const closeHelpModal = () => {
      emit("close");
    };
    return { closeHelpModal };
  },
});
</script>

<style>
.helpModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  overflow-x: scroll;
}

.helpModal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

.helpModal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
